import React from 'react';

import ActionBar from '../../components/ActionBar';

import SystemsTable from './SystemsTable';

import classes from './DataPanel.module.css';

const SystemPanelInsert = ({
    handleSearch,
    handleSort,
    systems,
    order,
    orderBy,
    showContextMenu,
    type,
    ...props
}) => {
    return (
        <React.Fragment>
            <ActionBar
                onSearch={(searchTerm) => {handleSearch(searchTerm, type);}}
            />
            <div className={classes.scrollContainer}>
                <SystemsTable
                    systems={systems}
                    order={order}
                    orderBy={orderBy}
                    onSort={handleSort}
                    showContextMenu={showContextMenu}
                />
            </div>
        </React.Fragment>
    );
};

export default SystemPanelInsert;
